export default {"src":"/_next/static/media/tick-circle.91cec0e7.svg","height":14,"width":15};